
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { IPropretyAttribute, IEntityMetaData } from "../../_models/IEntityMetaData";
import { PropretyAttributes, Validation, NestedProperty, NavigationProperty } from "../../decorators/EntityDecorators";
import { i18nLanguage } from "./i18nLanguage.model";

import { Account_Tenant_Admin } from "./Account_Tenant_Admin.model";
import { EmployeePresenceTemplate } from "./EmployeePresenceTemplate.model";
import { Account_POS_Admin } from "./navigation-entities/Account_POS_Admin.model";
import { Account_POS_Employee } from "./navigation-entities/Account_POS_Employee.model";
import { Account_POS_Login } from "./navigation-entities/Account_POS_Login.model";
import { Account_POS_ReadOnly } from "./navigation-entities/Account_POS_ReadOnly.model";
import { Role } from "./Role.model";
import { Account_POS } from "./navigation-entities/Account_POS.model";
import { RegexType } from "../../services/RegexPatternLibrary";
import { Register } from "../../decorators/DependencyInjectionRegistreyDecorators";
import { AccountBase } from "../AccountBase.model";


@Register({
  isModelEntity: true, namespace: 'Tenant', entityName: 'Account' // optionnel car par defaut utilise le nom de classe
})
export class Account extends AccountBase {


  managerAccount!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  name!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  @Validation({
    propertyType: RegexType.Email
  })
  email!: string;

  @Validation({ maxLength: 50 })
  phoneNumber?: string;

  @PropretyAttributes({ attributes: [] })
  twoFactorEnabled: boolean = false;

  @PropretyAttributes({ attributes: [IPropretyAttribute.RequiredOnlyCreation] })
  @Validation({
    propertyType: RegexType.StrongPassword,
    minLength: 8
  })
  password!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.CrossValidation] })
  @Validation({
    propertyType: RegexType.CrossValidation,
    crossValidationFieldName: 'password'
  })
  confirmPassword!: string;



  @PropretyAttributes({ attributes: [] })
  covidNotification!: boolean;

  @PropretyAttributes({ attributes: [] })
  dailyReport!: boolean;

  @PropretyAttributes({ attributes: [] })
  weeklyReport!: boolean;

  @PropretyAttributes({ attributes: [] })
  monthlyReport!: boolean;



  @NestedProperty({ TargetType: i18nLanguage })
  i18nLanguage?: i18nLanguage;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_i18nLanguage!: number;

  @NavigationProperty({ TargetType: Account_POS })
  accountPOS?: Account_POS[];

  @NavigationProperty({ TargetType: EmployeePresenceTemplate })
  ownedTemplates?: EmployeePresenceTemplate[];

  @NavigationProperty({ TargetType: EmployeePresenceTemplate })
  coOwnedTemplates?: EmployeePresenceTemplate[];

  @PropretyAttributes({ attributes: [] })
  managerClientId?: string;

  @NavigationProperty({ TargetType: Account })
  accounts?: Account[];

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  selectedPK_Pos: string[] = [];

  override GetType(): IEntityMetaData {
    return Account.getMetaData();
  }

  static override getMetaData(): IEntityMetaData {
    const baseMetaData = super.getMetaData();
    return {
      ...baseMetaData,
      EndPoint: "/tenantAccounts"
    };
  }


}
